import { render, staticRenderFns } from "./SuperShop.vue?vue&type=template&id=0d27811b&scoped=true&"
import script from "./SuperShop.vue?vue&type=script&lang=js&"
export * from "./SuperShop.vue?vue&type=script&lang=js&"
import style0 from "./SuperShop.vue?vue&type=style&index=0&id=0d27811b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d27811b",
  null
  
)

export default component.exports